exports = module.exports = require("../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".silver-scroll-list {\n  position: absolute;\n  overflow: hidden;\n  background-size: 100% auto;\n  background-repeat: no-repeat;\n}\n.silver-scroll-list .silver-scrollList {\n  float: left;\n  min-height: 100%;\n  width: 100%;\n  background-size: 100% auto;\n  background-repeat: no-repeat;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./~/silver-scroll-list/lib/index.less
// module id = 14
// module chunks = 0